import { Box, Button, Checkbox, Typography } from '@servicepipe/ui-components';
import React from 'react';

export const SectionHead = ({
  title,
  checkboxLabel,
  checkboxChecked,
  onCheckboxChange,
  buttonLabel,
  onButtonClick,
}) => (
  <Box justify="space-between" width="100%" align="center" wrap="wrap" gap="16px">
    <Typography variant="h6">{title}</Typography>

    <Box display="flex" gap="16px" align="center" wrap="wrap">
      {checkboxLabel && (
        <Checkbox
          label={checkboxLabel}
          checked={Boolean(checkboxChecked)}
          onChange={onCheckboxChange}
        />
      )}

      {buttonLabel && (
        <Button variant="solid" color="accent" onClick={onButtonClick}>
          {buttonLabel}
        </Button>
      )}
    </Box>
  </Box>
);
